import { useSelector } from 'react-redux';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { Accordion, UploadedEvidence } from 'src/components/molecules';
import { AccordionTitle } from 'src/components/molecules/Accordion/Accordion.styles';
import { UploadedEvidenceFile } from 'src/components/molecules/UploadedEvidence/types';
import { EventHeader } from 'src/components/organisms/EventDetailsAccordion/EventDetailsAccordion.styles';
import { postSubmissionEvidenceVm } from 'src/components/pages/Case/Case.slice';
import type { ReportType } from 'src/graphql';
import { useTheme } from 'styled-components';
import { UploadScanStatus } from 'src/types';
import { UploadedEvidenceContainer } from './PostSubmissionEvidence.styles';

interface PostSubmissionEvidenceProps {
  'data-testid'?: string;
  report: ReportType;
}

export const PostSubmissionEvidence = ({
  report,
  ...props
}: PostSubmissionEvidenceProps) => {
  const theme = useTheme();
  const isVaultVariant = theme.isVaultVariant;
  const { files }: { files: UploadedEvidenceFile[] } = useSelector(
    postSubmissionEvidenceVm({ reportId: report.id }),
  );
  if (!files.length) return null;

  const showErrorInHeader = files.some(
    (file) => file.status === UploadScanStatus.INFECTED,
  );
  const title = 'Evidence added after report submission';
  const availableFiles = files.filter((ev) => ev.dataDeletedAt === null);

  return availableFiles.length > 0 ? (
    <Accordion
      title={
        showErrorInHeader ? (
          <EventHeader>
            <AccordionTitle>{title}</AccordionTitle>
            <StyledIcon
              className="uil uil-exclamation-octagon"
              color={
                isVaultVariant
                  ? theme.newPalette.red.R300
                  : theme.atlas.semantic.color.status.error.default
              }
              size="24px"
              data-testid={`${props['data-testid']}-upload-error-icon`}
            />
          </EventHeader>
        ) : (
          title
        )
      }
      data-testid={props['data-testid']}
      topBorder
    >
      <UploadedEvidenceContainer>
        <UploadedEvidence
          files={availableFiles}
          reportId={report.id}
          caseManagerView
          hideTitle
          baseFileName="AdditionalEvidence"
        />
      </UploadedEvidenceContainer>
    </Accordion>
  ) : null;
};
